export enum MtReportSubject {
  Mentee,
  Mentor
}
